var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvancedSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.41 20.7898L12.0001 21.6998C10.6901 22.5098 8.87006 21.5998 8.87006 19.9798V14.6298C8.87006 13.9198 8.47006 13.0098 8.06006 12.5098L4.22003 8.46976C3.71003 7.95976 3.31006 7.05977 3.31006 6.44977V4.12976C3.31006 2.91976 4.22008 2.00977 5.33008 2.00977H18.67C19.78 2.00977 20.6901 2.91975 20.6901 4.02975V6.24976C20.6901 7.05976 20.1801 8.06976 19.6801 8.56976",
    stroke: "#1752AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0802 11.8904L13.5401 15.4304C13.4001 15.5704 13.2701 15.8304 13.2401 16.0204L13.0501 17.3704C12.9801 17.8604 13.3202 18.2004 13.8102 18.1304L15.1601 17.9404C15.3501 17.9104 15.6202 17.7804 15.7502 17.6404L19.2901 14.1004C19.9001 13.4904 20.1901 12.7804 19.2901 11.8804C18.4001 10.9904 17.6902 11.2804 17.0802 11.8904Z",
    stroke: "#1752AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5801 12.3906C16.8801 13.4706 17.72 14.3106 18.8 14.6106",
    stroke: "#1752AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedSearchIcon);
export default __webpack_public_path__ + "static/media/AdvancedSearchIcon.c1cc1b1f0e86b2c80d4b48d6b6f2b89a.svg";
export { ForwardRef as ReactComponent };